/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilitySeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ThreatVulnerabilitySeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return ThreatVulnerabilitySeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilitySeverityQueryOperator>): ThreatVulnerabilitySeverityQueryOperator {
        let obj = Object.assign(new ThreatVulnerabilitySeverityQueryOperator(), model);
        ThreatVulnerabilitySeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilitySeverityQueryOperator>): ThreatVulnerabilitySeverityQueryOperator {
        if (!model) return null;
        return ThreatVulnerabilitySeverityQueryOperator.newInstance(<ThreatVulnerabilitySeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilitySeverityQueryOperator) {
        if (!obj) return;

        models.ThreatVulnerabilitySeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilitySeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatVulnerabilitySeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Severities to include
     */
    severities: Array<models.Severity>;

}
